import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import { I18n } from "@aws-amplify/core";

import DropdownDown from './assets/dropdown_arrow_down.svg';
import DropdownRight from './assets/dropdown_arrow_right.svg';

const styles = {
  productRow: {
    boxSizing: "border-box",
    width: "100%",
    border: "1px solid #757575",
    borderRadius: "2px",
    marginBottom: "16px",
    '@media(max-width: 470px)': {
      backgroundColor: "#f8f8f8",
      marginBottom: "8px",
      border: "none",
    }
  },
  highlight: {
    backgroundColor: "#f8f8f8",
  },
  headerControl: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
  },
  imageContainer: {
    marginRight: "4px",
    width: "20px",
    height: "20px",
    display: "grid",
    placeItems: "center",
    cursor: "pointer",
  },
  text38: {
    color: "rgba(0, 0, 0, 0.38)",
  },
  text54: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  text100: {
    color: "rgba(0, 0, 0, 100)",
    fontWeight: "bold"
  },
  textRed: {
    color: "#eb3c39"
  },
  textBold: {
    fontWeight: "500"
  },
  orderDetails: {
    padding: "0px 0px 8px 8px",
    '@media(max-width: 470px)': {
      padding: "0px 0px 0px 8px",
    }
  },
  hiddenDetails: {
    padding: "8px",
    '@media(max-width: 470px)': {
      padding: "0px 8px 8px 8px",
    }
  },
  orderReplenishmentItems: {
    display: "flex",
    flexDirection: "column"
  },
  ordItemOutstanding: {
    display: "flex"
  },
  ordItem: {
    display: "flex",
    flexDirection: "column",
    marginRight: "32px",
    minWidth: "58px",
  },
  zoneDetails: {
    marginTop: "16px",
    display: "flex",
    '@media(max-width: 470px)': {
      marginTop: "8px",
    }
  },
  inventoryDetails: {
    marginTop: "16px",
  }
};

const generateDate = date => {
  const localDate = new Date(date + " UTC")
  return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/,/g, "")
}

function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}

const ProductLookupDialogRow = (props) => {
  const { classes, language } = props;

  const [isOpen, setIsOpen] = React.useState(false)
  const [maxQty, setMaxQty] = React.useState()
  const [minQty, setMinQty] = React.useState()
  const [invQty, setInvQty] = React.useState()

  React.useEffect(() => {
    if (getWidth() < 470) {
      setIsOpen(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (props.locationData.attributes.filter(att => att.sys_attribute_id === 223)[0]) {
      setMaxQty(props.locationData.attributes.filter(att => att.sys_attribute_id === 223)[0].attribute_value)
    }

    if (props.locationData.attributes.filter(att => att.sys_attribute_id === 224)[0]) {
      setMinQty(props.locationData.attributes.filter(att => att.sys_attribute_id === 224)[0].attribute_value)
    }

    if (props.locationData.inventory) {
      setInvQty(props.locationData.inventory)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.locationData])


  return (
    <div className={`${classes.productRow} ${props.i === 0 ? classes.highlight : ""}`} >
      <div className={classes.mobileRowHeader}>
        <div className={classes.headerControl}>
          <div className={classes.imageContainer} onClick={() => setIsOpen(!isOpen)} >
            <img src={isOpen ? DropdownDown : DropdownRight} alt="Dropdown" />
          </div>
          <div className={props.i === 0 ? classes.text100 : classes.text54}>{`${props.locationData.assigned} (${props.locationData.pzi_id})`}</div>
        </div>
        {props.locationData.quantity > 0 ?
          <div className={`${classes.orderDetails} ${classes.textRed}`}>
            <div className={classes.orderReplenishmentItems}>
              <div className={classes.ordItemOutstanding}>
                <div className={`${classes.itemCodeSubtitle}`}><span className={classes.textBold}>{`${I18n.get("ordered_quantity")}${language === "en" ? ": " : " : "}`}</span>{props.locationData.quantity}</div>
              </div>
              <div style={{ display: "flex" }}>
                <div className={classes.ordItem}>
                  <div className={`${classes.itemCodeSubtitle} ${classes.textBold}`}>{I18n.get("replenishment_outstanding")}</div>
                  <div>{props.locationData.outstanding_quantity}</div>
                </div>
                <div className={classes.ordItem}>
                  <div className={`${classes.itemCodeSubtitle} ${classes.textBold}`}>{I18n.get("replenishment_en_route")}</div>
                  <div>{props.locationData.transit_quantity}</div>
                </div>
                <div className={classes.ordItem}>
                  <div className={`${classes.itemCodeSubtitle} ${classes.textBold}`}>{I18n.get("replenishment_to_bin")}</div>
                  <div>{props.locationData.to_be_placed_quantity}</div>
                </div>
                <div className={classes.ordItem}>
                  <div className={`${classes.itemCodeSubtitle} ${classes.textBold}`}>{I18n.get("binned")}</div>
                  <div>{props.locationData.placed_quantity}</div>
                </div>
              </div>
            </div>
          </div> : null}
      </div>
      {isOpen ?
        <div className={classes.hiddenDetails}>
          <div className={classes.zoneDetails}>
            <div style={{ paddingRight: "40px" }}>
              <div className={classes.textBold}>MIN</div>
              <div>{`${I18n.get("quantity2")}${language === "en" ? ": " : " : "}`}{minQty ? `${minQty} ${I18n.get("unites").toLowerCase()}` : "-"}</div>
            </div>
            <div>
              <div className={classes.textBold}>MAX</div>
              <div>{`${I18n.get("quantity2")}${language === "en" ? ": " : " : "}`}{maxQty ? `${maxQty} ${I18n.get("unites").toLowerCase()}` : "-"}</div>
            </div>
          </div>
          <div className={classes.inventoryDetails}>
            <div><span className={classes.textBold}>{I18n.get("inventory")}</span>{`${language === "en" ? ": " : " : "}${invQty ? invQty : "-"}`}</div>
            {props.locationData.last_update ? <div style={{ fontStyle: "italic" }}>{`${I18n.get("lastUpdate")}${language === "en" ? ": " : " : "}${generateDate(props.locationData.last_update)}`}</div> : null}
          </div>
        </div>
        : null
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(ProductLookupDialogRow))

);